export const RoutesPaths = {
  all: '/*',
  auth: {
    root: '/auth/*',
    signIn: 'sign-in',
    passphrase: 'passphrase',
    role: 'role',
    '2fa': '2fa',
  },

  app: {
    root: '/app/*',
    search: 'search',
    users: {
      main: 'users',
      profile: ':userId',
      tabs: {
        overview: 'overview',
        kyckyb: 'kyckyb',
        wallets: {
          main: 'wallets',
          wallet: ':walletId',
        },
        cards: {
          main: 'cards',
          card: ':cardId',
        },
        beneficiaries: {
          main: 'beneficiaries',
          beneficiaryId: ':beneficiaryId',
        },
        children: 'children',
        companyMembers: 'company-members',
      },
    },
    createUser: 'create-user',
    cards: 'cards',
    wallets: 'wallets',
    beneficiaries: 'beneficiaries',
    cardTransactions: 'transactions',
    kycNeedReview: 'kyc-review',
    bulkCards: {
      main: 'bulk-cards',
      others: 'bulk-cards/*',
      orders: 'orders',
      create: 'create',
    },
    onboarding: 'onboarding',
    audits: 'audits',

    dashboardUsers: 'dashboard-users',
    accountOverview: 'account-overview',
    restrictions: {
      main: 'restrictions/groups',
      others: 'restrictions/groups/*',
      restrictionType: ':type',
      tabs: {
        mid: 'mid',
        mcc: 'mcc',
        country: 'country',
      },
      details: 'details/:groupId',
    },
    webhooks: 'webhooks',
    encryption: 'encryption',
    templates: 'templates',
    configuration: {
      main: 'configuration',
      others: 'configuration/*',
      tabs: {
        settings: 'settings',
        security: 'security',
        integration: 'integration',
      },
    },
  },
} as const;

export const routesTitles: { [key: string]: string } = {
  '/app/kyc-review': 'pages.administration.kycNeedReview.pages.title',
  '/app/create-user': 'pages.dashboard.createUser.title',
  '/app/search': 'pages.dashboard.search.title',
  '/app/users': 'pages.dashboard.users.title',
  '/app/transactions': 'pages.dashboard.card.transactions.title',
  '/app/cards': '',
  '/app/wallets': '',
  '/app/configuration/settings': 'pages.administration.configuration.title',
  '/app/audit': 'pages.administration.auditTrace.header',
  '/app/dashboard-users': 'pages.administration.supportsUsers.title',
  '/app/restrictions/groups/*': 'pages.administration.restrictionGroup.title',
  '/app/templates': 'pages.administration.templates.management',
  '/app/webhooks': 'pages.administration.webhooks.title',
  '/app/bulk-cards/*': 'pages.administration.bulkCards.title',
  '/app/onboarding': 'pages.administration.onBoarding.title',
};
